/* eslint-disable react/prop-types */
import {useState} from 'react'

import PropTypes from 'prop-types'

import {parseQueryString} from '@s-ui/js/lib/string'
import Helmet from '@s-ui/react-head'
import {useMount} from '@s-ui/react-hooks'
import EmptyCase from '@adv-mt/mt-empty-case-payment-ad'
import Layout from '@adv-mt/mt-layout-basic'
import NavigationRequireAuth from '@adv-mt/mt-navigation-require-auth'
import TrackingPageView from '@adv-mt/mt-tracking-page-view'

import LinkFactory from '../../components/LinkFactory/index.js'
const PaymentAd = ({helmet, domain, pageName, location, router, adId}) => {
  const [emptyCaseData, setEmptyCaseData] = useState()
  const CURRENT_PATH = location.pathname + location.search

  useMount(async () => {
    const {
      product: {
        price: {amountLabelValue},
        id
      }
    } = await domain.get('get_payment_ad_products_use_case').execute({adId})

    const emptyCaseData = {
      price: amountLabelValue,
      productId: id,
      adId
    }
    setEmptyCaseData(emptyCaseData)
  })

  return (
    <NavigationRequireAuth currentPath={CURRENT_PATH}>
      <Layout.Basic linkFactory={LinkFactory}>
        <div className="mt-PaymentAd">{emptyCaseData && <EmptyCase {...emptyCaseData} adId={adId} />}</div>
      </Layout.Basic>
      <Helmet {...helmet} />
      <TrackingPageView pageName={pageName} />
    </NavigationRequireAuth>
  )
}

PaymentAd.displayName = 'PaymentAd'

PaymentAd.getInitialProps = async ({routeInfo, context: {domain, i18n}}) => {
  const {
    location: {pathname: path, search}
  } = routeInfo
  const {adId} = parseQueryString(search)

  const initialPaymentAdFactory = async () => {
    const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})

    const [seoDataError, {head: helmet} = {}] = await domain
      .get('get_seo_data_use_case')
      .execute({culture: i18n.culture, pageName})

    return {
      helmet,
      pageName,
      adId,
      seoDataError
    }
  }

  const initialPaymentAd = await initialPaymentAdFactory()

  return initialPaymentAd
}

PaymentAd.propTypes = {
  domain: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  pageName: PropTypes.string.isRequired,
  adId: PropTypes.string.isRequired
}

export default PaymentAd
